import { render, staticRenderFns } from "./ChartDataLayout.vue?vue&type=template&id=b31d97f2&scoped=true"
import script from "./ChartDataLayout.ts?vue&type=script&lang=ts&external"
export * from "./ChartDataLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./ChartDataLayout.scss?vue&type=style&index=0&id=b31d97f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31d97f2",
  null
  
)

export default component.exports